import { create } from 'zustand';
import { persist, devtools } from 'zustand/middleware';
import { createBusinessSlice } from './slices/createBusinessSlice';
import { createAuthSlice } from './slices/createAuthSlice';
import { createUserSlice } from './slices/createUserSlice';
import { createMarketersListSlice } from './slices/createMarketersListSlice';
import { createQuickAccessSlice } from './slices/createQuickAccessSlice';

export const usePersistedStore = create()(
    devtools(
        persist(
            (set, get) => ({
                ...createAuthSlice(set, get),
                ...createUserSlice(set, get),
                ...createMarketersListSlice(set, get),
                ...createBusinessSlice(set, get),
                ...createQuickAccessSlice(set, get),
            }),
            {
                name: 'app-store',
                onRehydrateStorage: () => (state) => {
                    if (state?.auth) {
                        state.auth.loading = false;
                    }
                },
            },
        )),
)

